import { useState } from "react";

import { ItemTemplate, NoResultsTemplate } from "@Components/Repeater";
import RepeaterV2 from "@Components/Repeater/RepeaterV2";
import { LinkV2 } from "@Layout/ButtonLink";

import type { IDiscountTile } from "../discount/DiscountTile";
import DiscountTile from "../discount/DiscountTile";

import * as css from "./BrandDetails.module.css";

export interface IBrandDetailsContent {
    description?: string;
    showDiscountsText?: string;
    noDiscountsDescription: string;
    showOnNoDiscounts: boolean;
    discounts: IDiscountTile[];
}

export const BrandDetailsContent = (props: IBrandDetailsContent) => {
    const [showDiscounts, setShowDiscounts] = useState(!props.showDiscountsText);

    if (!props.discounts?.length && !props.showOnNoDiscounts) {
        return <h1>{!props.discounts?.length}</h1>;
    }

    return (
        <section className={css.brandDetailsContentComponent}>
            {props.showDiscountsText && !showDiscounts && (
                <div className={css.textCenter}>
                    <LinkV2 onClick={() => setShowDiscounts(true)}>{props.showDiscountsText}</LinkV2>
                </div>
            )}
            {showDiscounts && (
                <div className={css.discounts}>
                    {props.description && <h2>{props.description}</h2>}
                    <RepeaterV2
                        initialData={
                            props.discounts && props.discounts.map((val) => ({ ...val, key: val.id }))
                        }
                        noResultsTemplate={
                            <NoResultsTemplate>{props.noDiscountsDescription}</NoResultsTemplate>
                        }
                    >
                        <ItemTemplate>
                            <DiscountTile
                                {...({} as IDiscountTile)}
                                descriptionElement="h3"
                                origin={"BrandDetails"}
                            />
                        </ItemTemplate>
                    </RepeaterV2>
                </div>
            )}
        </section>
    );
};
